import React from 'react';
import { css } from 'styled-components';

type Props = {
  onClick?: any;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
};

const TouchableItem: React.FC<Props> = React.forwardRef<HTMLDivElement>(
  ({ children, className = undefined, onClick, ...rest }: Props, ref) => {
    return (
      <span
        ref={ref}
        css={css`
          cursor: ${onClick ? 'pointer' : 'initial'};
        `}
        onClick={onClick}
        className={className}
        {...rest}
      >
        {children}
      </span>
    );
  }
);

export default TouchableItem;
